import { ref } from "vue";

export const orderIsOpen = ref(false)